module.exports = __webpack_public_path__ + "img/icon_1_14.20615094.png";